
<template>
<!--<my-resume/>-->
<router-view/>
</template>

<!--<script>
import MyResume from'./components/MyResume.vue';
export default {
components:{ 
MyResume,
} 
};
</script>-->